/**
 * @module ol-ishare/control/gazetteer
 */

// TODO Tests

// TODO Default logic for zooming to extent (bbox) or point (coord);
//      there would need to be someway of overriding or disabling the default

import Control from 'ol/control/Control';
import { Gazetteer as UiGazetteer } from '../ui/gazetteer.js';

/**
 * Autocomplete Gazetteer search map control
 * @class
 * @classdesc Auto-complete address search control for use with an OpenLayers map
 *
 * If any of the `placeholder`, `noResults`, `queryTooShort`, `selectedOption`,
 * `resultsDescription` or `assistiveHint` options are unset, the iShare server
 * version is >= v6.0.9, your langauge file contains matching properties under
 * `oli.gazetteer` and the lang UI text lookup is available when this control
 * is created then the entries from the language file will be used. Otherwise
 * the default English values will be used. The lang lookup is automatically
 * loaded when creating a LiteMap and is populated once the `load` event is
 * dispatched.
 *
 * @param {module:ol-ishare/ui/gazetteer~GazetteerOptions} opt_options Gazetteer options
 */
var Gazetteer = (function (Control) {
  function Gazetteer(opt_options) {
    var options = opt_options || {};

    var element = document.createElement('div');
    element.className = 'oli-gazetteer ol-unselectable ol-control';

    Control.call(this, {
      element: element,
      target: options.target
    });

    this.gaz = new UiGazetteer({
      iShareUrl: options.iShareUrl,
      profile: options.profile,
      sources: options.sources,
      placeholder: options.placeholder,
      noResults: options.noResults,
      queryTooShort: options.queryTooShort,
      selectedOption: options.selectedOption,
      resultsDescription: options.resultsDescription,
      assistiveHint: options.assistiveHint,
      target: element
    });

    var that = this;
    this.gaz.on('select', function (evt) {
      that.dispatchEvent({ type: 'select', result: evt.result });
    });
  }

  if (Control) Gazetteer.__proto__ = Control;
  Gazetteer.prototype = Object.create(Control && Control.prototype);
  Gazetteer.prototype.constructor = Gazetteer;

  return Gazetteer;
})(Control);

export { Gazetteer };
